import numberIsNaNPolyfill from './number_is_na_n_polyfill';
import numberParseIntPolyfill from './number_parse_int_polyfill';

numberIsNaNPolyfill();
numberParseIntPolyfill();
